import templateUrl from "emun.salesrep/customer-totals-vendor.htm";
import controller from "emun.salesrep/customer-totals-vendor.controller";

export default {
  bindings: {
    entity: "<",
    context: "@",
    title: "@"
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};
